/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import lity from "lity";
var DYNAMIC_PAGINATION_BREAKPOINT = 1125;
var CAROUSEL_SELECTOR = '.paragraph--type--ss-provider-carousel';
var PLAY_BUTTONS_SELECTOR = '.provider-video-button';
var TRUE = 'true';
var ProvidersCarousel = function () {
  function ProvidersCarousel() {
    _classCallCheck(this, ProvidersCarousel);
    this.initializeAllCarousels = this.initializeAllCarousels.bind(this);
    this.handleDocumentLoaded = this.handleDocumentLoaded.bind(this);
  }
  return _createClass(ProvidersCarousel, [{
    key: "getSlidesPerGroup",
    value: function getSlidesPerGroup() {
      if (this.providerCarousel.classList.contains('paragraph--view-mode--specialty') || this.providerCarousel.classList.contains('paragraph--view-mode--location')) {
        return ProvidersCarousel.getSpecialtySlidesPerGroup();
      }
      return ProvidersCarousel.getSuperSpecialtySlidesPerGroup();
    }
  }, {
    key: "getTotalSlides",
    value: function getTotalSlides() {
      return this.providerCarousel.querySelectorAll('.swiper-slide').length;
    }
  }, {
    key: "calculateDynamicMainBullets",
    value: function calculateDynamicMainBullets() {
      var totalSlides = this.getTotalSlides();
      return Math.min(totalSlides, 10);
    }
  }, {
    key: "initializeSwiper",
    value: function initializeSwiper() {
      this.calculateDynamicMainBullets();
      this.swiper = new Swiper(this.providerCarousel.querySelector('.carousel--wrapper.swiper'), {
        freeMode: {
          enabled: false
        },
        updateOnWindowResize: true,
        slidesPerGroup: 1,
        centeredSlides: false,
        slidesPerView: 'auto',
        spaceBetween: 15,
        pagination: {
          clickable: true,
          type: 'bullets',
          el: '.swiper-pagination',
          dynamicBullets: true,
          dynamicMainBullets: 3
        },
        edgeSwipeThreshold: 150,
        navigation: {
          nextEl: this.providerCarousel.querySelector('.right-button'),
          prevEl: this.providerCarousel.querySelector('.left-button')
        },
        createElements: true,
        keyboard: true,
        breakpoints: {
          1370: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false
          },
          1125: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false
          },
          1045: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false
          },
          1024: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false
          }
        }
      });
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this = this;
      document.addEventListener('DOMContentLoaded', this.handleDocumentLoaded);
      if (this.providerCarousel) {
        window.removeEventListener('resize', function () {
          if (window.innerWidth > DYNAMIC_PAGINATION_BREAKPOINT) {
            ProvidersCarousel.removeSwiperDynamicPaginationClassAndHardcodedWidth();
          }
          if (typeof _this.swiper.destroy === 'function') {
            _this.swiper.destroy();
          }
          _this.initializeSwiper();
        });
        this.playButtons.forEach(function (button) {
          button.removeEventListener('click', function (event) {
            var _event$currentTarget$;
            var youtubeUrl = (_event$currentTarget$ = event.currentTarget.parentElement.querySelector('.field--name-field-media-oembed-video')) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.innerHTML;
            if (!youtubeUrl) {
              return;
            }
            lity(youtubeUrl);
          });
          button.addEventListener('click', function (event) {
            var _event$currentTarget$2;
            var youtubeUrl = (_event$currentTarget$2 = event.currentTarget.parentElement.querySelector('.field--name-field-media-oembed-video')) === null || _event$currentTarget$2 === void 0 ? void 0 : _event$currentTarget$2.innerHTML;
            if (!youtubeUrl) {
              return;
            }
            lity(youtubeUrl);
          });
        });
        window.addEventListener('resize', function () {
          if (window.innerWidth > DYNAMIC_PAGINATION_BREAKPOINT) {
            ProvidersCarousel.removeSwiperDynamicPaginationClassAndHardcodedWidth();
          }
          if (typeof _this.swiper.destroy === 'function') {
            _this.swiper.destroy();
          }
          _this.initializeSwiper();
        });
      }
    }
  }, {
    key: "providerCarousel",
    get: function get() {
      return this._providerCarousel || this.allProviderCarousels[0] || document.querySelector(this.selector);
    },
    set: function set(providerCarousel) {
      this._providerCarousel = providerCarousel;
    }
  }, {
    key: "allProviderCarousels",
    get: function get() {
      return this._allProviderCarousels || [];
    },
    set: function set(carousels) {
      this._allProviderCarousels = carousels;
    }
  }, {
    key: "playButtons",
    get: function get() {
      return this._playButtons || [];
    },
    set: function set(playButtonElements) {
      this._playButtons = playButtonElements;
    }
  }, {
    key: "selector",
    get: function get() {
      return this._selector || CAROUSEL_SELECTOR;
    },
    set: function set(selector) {
      this._selector = selector;
    }
  }, {
    key: "allCarouselsInitialized",
    get: function get() {
      return this._allCarouselsInitialized;
    },
    set: function set(initializedState) {
      this._allCarouselsInitialized = initializedState;
    }
  }, {
    key: "swiper",
    get: function get() {
      return this._swiper || new Swiper(this.defaultSwiperElement, this.defaultSwiperOptions);
    },
    set: function set(swiper) {
      this._swiper = swiper;
    }
  }, {
    key: "defaultSwiperElement",
    get: function get() {
      return this._defaultSwiperElement || this.providerCarousel.querySelector('.carousel--wrapper.swiper');
    },
    set: function set(element) {
      this._defaultSwiperElement = element;
    }
  }, {
    key: "defaultSwiperOptions",
    get: function get() {
      return this._defaultSwiperOptions || {
        freeMode: {
          enabled: false
        },
        updateOnWindowResize: true,
        slidesPerGroup: 1,
        centeredSlides: false,
        slidesPerView: 'auto',
        spaceBetween: 15,
        pagination: {
          clickable: true,
          type: 'bullets',
          el: '.swiper-pagination',
          dynamicBullets: true,
          dynamicMainBullets: 1
        },
        edgeSwipeThreshold: 150,
        navigation: {
          nextEl: this.providerCarousel.querySelector('.right-button'),
          prevEl: this.providerCarousel.querySelector('.left-button')
        },
        createElements: true,
        keyboard: true,
        breakpoints: {
          1370: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false,
            pagination: {
              dynamicBullets: true,
              dynamicMainBullets: 35
            }
          },
          1125: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false,
            pagination: {
              dynamicBullets: true,
              dynamicMainBullets: 25
            }
          },
          1045: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false,
            pagination: {
              dynamicBullets: true,
              dynamicMainBullets: 18
            }
          },
          1024: {
            slidesPerGroup: this.getSlidesPerGroup(),
            centeredSlides: false,
            pagination: {
              dynamicBullets: true,
              dynamicMainBullets: 12
            }
          }
        }
      };
    },
    set: function set(options) {
      this._defaultSwiperOptions = options;
    }
  }, {
    key: "handleDocumentLoaded",
    value: function handleDocumentLoaded() {
      this.initializeAllCarousels();
    }
  }, {
    key: "initializeAllCarousels",
    value: function initializeAllCarousels() {
      var _this2 = this;
      if (this.allCarouselsInitialized === TRUE) {
        return;
      }
      var carouselElements = document.querySelectorAll(this.selector);
      var providerCarousels = [];
      carouselElements.forEach(function (carouselElement) {
        var providerCarousel = new ProvidersCarousel();
        _this2.providerCarousel = providerCarousel;
        providerCarousel.providerCarousel = carouselElement;
        providerCarousels.push(providerCarousel);
      });
      providerCarousels.forEach(function (carousel) {
        carousel.playButtons = carousel.providerCarousel.querySelectorAll(PLAY_BUTTONS_SELECTOR);
        carousel.initializeSwiper();
        carousel.setListeners();
        carousel.allCarouselsInitialized = TRUE;
      });
      this.allProviderCarousels = providerCarousels;
      this.allCarouselsInitialized = TRUE;
    }
  }], [{
    key: "getSuperSpecialtySlidesPerGroup",
    value: function getSuperSpecialtySlidesPerGroup() {
      var widthThatStartsToHideThirdCard = 1370;
      if (window.innerWidth <= widthThatStartsToHideThirdCard) {
        return 4;
      }
      return 5;
    }
  }, {
    key: "getSpecialtySlidesPerGroup",
    value: function getSpecialtySlidesPerGroup() {
      var widthThatStartsToHideThirdCard = 1045;
      if (window.innerWidth <= widthThatStartsToHideThirdCard) {
        return 2;
      }
      return 3;
    }
  }, {
    key: "removeSwiperDynamicPaginationClassAndHardcodedWidth",
    value: function removeSwiperDynamicPaginationClassAndHardcodedWidth() {
      var paginationDiv = document.querySelector('.swiper-pagination');
      paginationDiv.classList.remove('swiper-pagination-bullets-dynamic');
      paginationDiv.removeAttribute('style');
    }
  }]);
}();
export { ProvidersCarousel as default };
(function () {
  var providersCarousel = new ProvidersCarousel();
  providersCarousel.setListeners();
})(Drupal);